import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, IsNumber, ValidateNested } from 'class-validator';

export class CreateEngagementStatusDto {
	@IsNotEmpty({ message: 'Required field' })
	statusName: string;

	color: string;

	@IsNumber()
	order: number;
}

export class CreateArrayEngagementStatusesDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateEngagementStatusDto)
	statuses?: Array<CreateEngagementStatusDto>;
}
